import React, { useMemo } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import classnames from 'classnames'
import { noop } from 'lodash'

export interface SharedProps extends IconProps {
  alt: string
  id?: string
  className?: string
  fill?: Color
  onClick?: () => void
}

const Shared: React.FC<SharedProps> = ({
  alt,
  id,
  fill = '#232829',
  className,
  onClick = noop
}) => {
  const markup = useMemo(
    () =>
      encodeURIComponent(
        renderToStaticMarkup(
          <svg
            width="23"
            height="18"
            viewBox="0 0 23 18"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.1793 9.72843L11.1743 9.73605C11.0978 9.85141 11.0125 9.98025 10.9169 10.123L10.8709 10.1918L10.9299 10.2499C11.7486 11.0553 12.2718 11.5819 12.6556 12.238C13.0385 12.8926 13.286 13.6826 13.5353 15.0184L13.5506 15.1H20.8951C21.5618 15.1 22.1131 14.599 22.0998 13.9707C22.0601 12.0873 21.4207 10.3525 20.3613 9.06722C19.3018 7.78172 17.7733 6.90002 16 6.90002C14.2268 6.90002 12.6982 7.78172 11.6387 9.06722C11.5297 9.19955 11.3849 9.41811 11.1793 9.72843ZM16.1336 6.70002C17.8391 6.70002 19.2336 5.40804 19.2336 3.80002C19.2336 2.19201 17.8391 0.900024 16.1336 0.900024C14.4282 0.900024 13.0336 2.19201 13.0336 3.80002C13.0336 5.40804 14.4282 6.70002 16.1336 6.70002ZM18.1765 3.80002C18.1765 4.84298 17.2685 5.70002 16.1336 5.70002C14.9988 5.70002 14.0908 4.84298 14.0908 3.80002C14.0908 2.75707 14.9988 1.90002 16.1336 1.90002C17.2685 1.90002 18.1765 2.75707 18.1765 3.80002ZM7.00003 8.70002C8.7055 8.70002 10.1 7.40804 10.1 5.80002C10.1 4.19201 8.7055 2.90002 7.00003 2.90002C5.29456 2.90002 3.90003 4.19201 3.90003 5.80002C3.90003 7.40804 5.29456 8.70002 7.00003 8.70002ZM9.04289 5.80002C9.04289 6.84298 8.13488 7.70002 7.00003 7.70002C5.86518 7.70002 4.95717 6.84298 4.95717 5.80002C4.95717 4.75707 5.86518 3.90002 7.00003 3.90002C8.13488 3.90002 9.04289 4.75707 9.04289 5.80002ZM20.9767 13.9911C20.9773 14.0194 20.9501 14.0579 20.8951 14.0579H14.4405C14.2006 12.2713 13.2247 11.2018 12.2053 10.1352C13.1223 8.7884 14.4853 7.94213 16 7.94213C18.6862 7.94213 20.9054 10.6145 20.9767 13.9911ZM0.900264 16.039C0.88676 16.6361 1.44534 17.1 2.10496 17.1H11.8951C12.5547 17.1 13.1133 16.6361 13.0998 16.039C13.06 14.278 12.4194 12.6566 11.3591 11.4559C10.2987 10.255 8.77064 9.43336 7.00003 9.43336C5.22942 9.43336 3.7014 10.255 2.64094 11.4559C1.58067 12.6566 0.940094 14.278 0.900264 16.039ZM11.9767 16.0587C11.9769 16.0684 11.9728 16.0805 11.9593 16.0923C11.9455 16.1043 11.9232 16.1141 11.8951 16.1141H2.10496C2.07688 16.1141 2.0546 16.1043 2.04078 16.0923C2.02724 16.0805 2.02317 16.0684 2.02339 16.0587C2.09446 12.9161 4.30821 10.4193 7.00003 10.4193C9.69184 10.4193 11.9056 12.9161 11.9767 16.0587Z"
              fill={fill}
            />
          </svg>
        )
      ),
    [fill]
  )

  return (
    <img
      alt={alt}
      id={id}
      onClick={onClick}
      className={classnames('shared-icon', className)}
      src={`data:image/svg+xml,${markup}`}
    />
  )
}

Shared.displayName = 'Shared'
export default Shared
